export default function getInvalidAddressFormConfig(args) {
  const { getConfig, editMode = false, initialValues, isPaypalExpress = false } = args;

  return (params) =>
    getConfig({
      ...params,
      editMode,
      enableGBCounty: !!initialValues?.countyStateOrProvince,
      isPaypalExpress,
    });
}
